import { useEffect, useState } from "react";
import { getOrderHisById} from "../../services/OrderHisServices";
import { getOrderHisDetailPanel} from "../../services/OrderHisDetailServices";
import { PedidosHistorialFormContext } from "./PedidosHistorialContext";
import { useParams } from 'react-router-dom';

export const PedidosHistorialFormState = ({ children }) => {
    const [report, setReport] = useState({});

    const { id } = useParams();

    useEffect(() => {
        if (id) getPedidoHisByIdData(id);
    }, [id]);

    async function getPedidoHisByIdData(id) {
        try {
            const res = await getOrderHisById(id);
            const data = await getOrderHisDetailPanel(id,null, 1, 250);
            let acuImporte=0;

            if (data ) {
                const total = data.orderHisDetails.reduce((sum, item) => sum + (item.ode_total_amount || 0), 0);
                acuImporte = total;
            } else {
                acuImporte=0;
            }
    
            if (res) {
                try {
                    setReport({
                        ...res,
                        totalImporte: acuImporte,
                    });
                } catch (error) {
                    console.error("Error al obtener los datos del pedido: ", error);
                }
            }
        } catch (error) {
            console.error("Error al obtener los datos del pedido: ", error);
        }
    }
    
    return (
        <PedidosHistorialFormContext.Provider value={{
            report,
        }}>
            {children}
        </PedidosHistorialFormContext.Provider>
    );
};
